'use client'

import dynamic from 'next/dynamic'
import { TFaqServerData } from 'services/faq/faqTypes'

import { RenderOnScroll } from '@/components/RenderOnScroll'

const DynamicLandingFaq = dynamic(() =>
	import('./LandingFaq').then((mod) => mod.LandingFaq),
)

type LazyLandingFaqProps = TFaqServerData & {
	showTabs?: boolean
}

export const LazyLandingFaq = (props: LazyLandingFaqProps) => (
	<RenderOnScroll element={<DynamicLandingFaq {...props} />} />
)
